import { render, staticRenderFns } from "./onlineBooking.vue?vue&type=template&id=cfbebabc&scoped=true"
import script from "./onlineBooking.vue?vue&type=script&lang=ts"
export * from "./onlineBooking.vue?vue&type=script&lang=ts"
import style0 from "./onlineBooking.vue?vue&type=style&index=0&id=cfbebabc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbebabc",
  null
  
)

export default component.exports